import api, { upload } from "actions/api.js"


export function getFiles(personid) {
    return api(`profile/${personid}/files`)
}

export function postFile(formData) {
    return upload({
        method: "POST",
        body: formData
    })
}

export function deleteFile(id) {
    return api(`personfile/${id}`,
        {
            method: "DELETE"
        })
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/files/api.js
 **/